import styled from '@emotion/styled';
import { createTheme, Grid, Typography } from '@mui/material';

export const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

export const Body = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '50px',
  width: '90%',
  marginTop: '130px',
  '@media (max-width: 420px)': {
    marginTop: '20px',
  },
}));

export const Container = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const ContentGrid = styled(Grid)(() => ({
  display: 'flex',
}));

export const TitleText = styled(Typography)(() => ({
  color: '#ffffff',
  fontSize: '25px',
  fontWeight: 'bold',
  paddingBottom: '10px',
}));
export const ParaText = styled(TitleText)(() => ({
  paddingBottom: '35px',
  fontSize: '16px',
  color: '#c1c1c1',
  fontWeight: 'normal',
}));

export const SubmitButton = ({ text }: any) => {
  return (
    <button
      type="submit"
      style={{
        backgroundColor: '#D1B22C',
        width: '100%',
        padding: '10px 15px',
        borderRadius: '15px',
        color: 'white',
        cursor: 'pointer',
        fontSize: '18px',
      }}
    >
      {text}
    </button>
  );
};
